var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.181641,
    y: 0.294922,
    width: 40.0674,
    height: 41.3599,
    rx: 20.0337,
    fill: "#43B678"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1047_10170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3025 16.6611V11.018C23.1007 11.3194 23.8257 11.7871 24.4295 12.3899L27.4357 15.3979C28.0392 16.0009 28.5072 16.7257 28.8085 17.5239H23.1654C22.9365 17.5239 22.7171 17.433 22.5552 17.2712C22.3934 17.1094 22.3025 16.8899 22.3025 16.6611ZM29.2054 19.6681V27.0154C29.204 28.1592 28.749 29.2557 27.9402 30.0645C27.1314 30.8733 26.0349 31.3283 24.8911 31.3296H16.2625C15.1187 31.3283 14.0222 30.8733 13.2134 30.0645C12.4046 29.2557 11.9496 28.1592 11.9482 27.0154V14.9354C11.9496 13.7916 12.4046 12.695 13.2134 11.8862C14.0222 11.0774 15.1187 10.6225 16.2625 10.6211H20.1583C20.299 10.6211 20.4379 10.6323 20.5768 10.6418V16.6611C20.5768 17.3476 20.8495 18.006 21.335 18.4915C21.8204 18.9769 22.4788 19.2497 23.1654 19.2497H29.1847C29.1942 19.3886 29.2054 19.5275 29.2054 19.6681ZM22.3025 27.0154C22.3025 26.7865 22.2116 26.567 22.0498 26.4052C21.888 26.2434 21.6685 26.1525 21.4397 26.1525H17.1254C16.8965 26.1525 16.6771 26.2434 16.5152 26.4052C16.3534 26.567 16.2625 26.7865 16.2625 27.0154C16.2625 27.2442 16.3534 27.4637 16.5152 27.6255C16.6771 27.7873 16.8965 27.8782 17.1254 27.8782H21.4397C21.6685 27.8782 21.888 27.7873 22.0498 27.6255C22.2116 27.4637 22.3025 27.2442 22.3025 27.0154ZM24.8911 23.5639C24.8911 23.3351 24.8002 23.1156 24.6384 22.9538C24.4765 22.792 24.2571 22.7011 24.0282 22.7011H17.1254C16.8965 22.7011 16.6771 22.792 16.5152 22.9538C16.3534 23.1156 16.2625 23.3351 16.2625 23.5639C16.2625 23.7928 16.3534 24.0123 16.5152 24.1741C16.6771 24.3359 16.8965 24.4268 17.1254 24.4268H24.0282C24.2571 24.4268 24.4765 24.3359 24.6384 24.1741C24.8002 24.0123 24.8911 23.7928 24.8911 23.5639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1047_10170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7086,
    height: 20.7086,
    fill: "white",
    transform: "translate(10.2217 10.6211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocGreen);
export default __webpack_public_path__ + "static/media/icon-doc-green.560cbe3070e91aa8cd1ea674c99f7f24.svg";
export { ForwardRef as ReactComponent };